module.exports = __webpack_public_path__ + "img/code-browser.a5b047fb.svg";